<template>
	<div  class="zjzj"><!-- zjzj -->
		<ul class="title1">
			<li class="L"><router-link to="/zhuanjia">中经专家</router-link></li>
			<li class="M"></li>
			<li class="R"><router-link to="/zhuanjia" class="more3">更多</router-link></li>
		</ul>
		<el-skeleton :rows="6" :loading="isloading" animated >
		<div  class="zjzj_list"><!-- zjzj_list -->
			<item v-for="(item,index) in zhuanjiaList" class="item"><!-- item -->
				<div class="pic"><img :src="item.expertphotocontent" /></div>
				<div  class="list"  >
					<div>
						<h2>{{item.expertname}}</h2>
						<h3>{{item.expertintroduce}}</h3>
					</div>
					<!-- <a href=""   class="more1" ></a> -->
				</div>
			</item><!-- /item -->
		</div><!-- /zjzj_list -->
		</el-skeleton>
	</div><!-- /zjzj -->
	
</template>

<script>
	export default {
		data() {
			return {
				isloading:true,
				zhuanjiaList: [],
			}
		},
		created:function(){
			this.zhuanjiafnc();
		},
		computed: {
	
		},
		methods: {
			zhuanjiafnc: function() {
				let _this = this;
				// this.resultDataList = {};
				// this.totalResultCount = 0;
				this.$http({
						method: 'get',
						url: 'selectTopExpertsInfos',
						responseType: 'json',
						params: {
							top: '3',
						},
					})
					.then(function(response) {
						// console.log(response);
						// debugger;
						_this.zhuanjiaList = response.data.data.data;
						_this.isloading=false;
					})
					.catch(function(error) {
						console.log(error);
					});;
			},
		}
	}
</script>

<style>
</style>
